import { db } from './firebaseConfig';
import { doc, updateDoc } from 'firebase/firestore';

const ActualizarEmpresaDb = async ({
  id,
  empresa,
  rut,
  plan,
  estado,
  maxUsers,
  logoUrl,
  logoPath,
  contrato_mantencion,
  usa_logisticmed_st,
  userMod,
  fechaMod,
}) => {
  const docum = doc(db, "empresas", id);

  return await updateDoc(docum, {
    empresa,
    rut,
    plan,
    estado,
    maxUsers,
    logoUrl,
    logoPath,

    contrato_mantencion: contrato_mantencion === true,
    usa_logisticmed_st: usa_logisticmed_st === true,

    userMod,
    fechaMod,
  });
};

export default ActualizarEmpresaDb;